
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"1em","height":"1em","fill":"currentColor","viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M16.15 3.131c.676.143.825.965.337 1.453L14.9 6.172A2 2 0 1017.727 9l1.587-1.587c.488-.488 1.31-.34 1.453.336a6.002 6.002 0 01-8.456 6.666l-5.898 5.899a2 2 0 11-2.828-2.829l5.898-5.898a6.003 6.003 0 016.667-8.456z"}})])
          )
        }
      }
    